import React, { useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import useCurrentUser from './useCurrentUser'

const defaultLoading = 'Authorizing...'

/** Cloned from https://github.com/seasonedcc/croods-auth/blob/master/src/Auth.js
 * This version uses the customized useCurrentUser
 */
const Auth = ({
  Component,
  authorizing = defaultLoading,
  unauthorized,
  unauthorize,
  ...props
}) => {
  const [{ currentUser, validating }, setCurrentUser] = useCurrentUser({
    afterFailure: () => unauthorized(currentUser),
  })

  useLayoutEffect(() => {
    if (unauthorize && currentUser) {
      unauthorize(currentUser) && unauthorized(currentUser)
    }
  }, [currentUser, unauthorize, unauthorized])

  return validating || !currentUser ? (
    authorizing
  ) : (
    <Component
      {...props}
      currentUser={currentUser}
      setCurrentUser={setCurrentUser}
    />
  )
}

Auth.propTypes = {
  Component: PropTypes.elementType.isRequired,
  unauthorized: PropTypes.func.isRequired,
  unauthorize: PropTypes.func,
  authorizing: PropTypes.node,
}

export default Auth
